import { Form, message, Spin } from 'antd';
import { Loader, Modal, Result404 } from 'components';
import { UpdateTermDTO } from 'features/community/api/community-api.service';
import { TermFormDataFields } from 'features/community/components/interface/type';
import { useGetCancellationList } from 'features/package/use-cases/get-cancellation-policy';
import { useUpdateCancellation } from 'features/package/use-cases/update.cancellation-policy';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { useEffect, useState } from 'react';

import { TermCancellationInfoFormItems } from './cancellation-info-form-items';
export const EditCancellationModal = ({
  onClose,
  onSuccess,
  id,
}: {
  onClose: () => void;
  onSuccess: () => void;
  id: string;
}) => {
  const [form] = Form.useForm();
  const [validateTrigger] = useState(['onSubmit']);
  const formName = 'edit-user-form';
  //   const { id } = useParams();
  const userQueryResult = useGetCancellationList('' as any);
  const {
    isLoading: isLoadingGet,
    isFetching: isFetchingGet,
    data: termdata,
    isError: isErrorQuestion,
  } = userQueryResult;
  const { mutate: mutateUpdateTerm, isLoading: isLoadingUpdateQuestion } =
    useUpdateCancellation();
  const isLoading = {
    loading: isLoadingGet || isFetchingGet || isLoadingUpdateQuestion,
    isFetchingGet,
    isLoadingUpdateQuestion,
  };
  const handleUpdate = (formData: TermFormDataFields) => {
    if (!formData.content_english.trim().replace(/<[^>]*>?/gm, '').length) {
      message.warning('Please enter content in English.');

      return;
    }
    if (!formData.content_arabic.trim().replace(/<[^>]*>?/gm, '').length) {
      message.warning('Please enter content in Arabic.');

      return;
    }
    const payload: UpdateTermDTO = {
      id: id,
      content_english: formData.content_english,
      content_arabic: formData.content_arabic,
    };
    mutateUpdateTerm(payload as any, { onSuccess });
  };
  //   const getInitialValues = () => ({
  //     [TermFormFields.content_english]: termdata?.content,
  //   });
  useEffect(() => {
    form.setFieldValue('content_english', termdata?.content_english);
    form.setFieldValue('content_arabic', termdata?.content_arabic);
  }, []);

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        className='right-modal editer_text'
        title={'Update Cancellation-policy'}
        onCancel={() => {
          document.body.style.overflow = 'auto';
          onClose(); // Call onClose function
        }}
        getContainer={false}
        onOk={form.submit}
        okText={'Update'}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{
          form: formName,
        }}
      >
        {isFetchingGet ? (
          <Loader />
        ) : isErrorQuestion ? (
          <Result404 />
        ) : (
          <Spin spinning={isLoading.loading}>
            <Form
              id={formName}
              name={formName}
              form={form}
              layout='vertical'
              //   initialValues={getInitialValues}
              requiredMark={'optional'}
              // onFinishFailed={onFinishFailed}
              validateTrigger={validateTrigger}
              disabled={isLoading.loading}
              onFinish={handleUpdate}
            >
              <TermCancellationInfoFormItems form={form} />
              {/* <PasswordFormItems title={t('adminUsers.accountInfo')} /> */}
            </Form>
          </Spin>
        )}
      </Modal>
    </StyledUserModalWrapper>
  );
};
